import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import AnimatedSection from './AnimatedSection';

const ELFSIGHT_SCRIPT_URL = 'https://static.elfsight.com/platform/platform.js';

const Videos = () => {
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    const existing = document.querySelector(`script[src="${ELFSIGHT_SCRIPT_URL}"]`);
    if (existing) return;
    const script = document.createElement('script');
    script.src = ELFSIGHT_SCRIPT_URL;
    script.setAttribute('data-use-service-core', '');
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="videos" className="section-padding bg-rustic-cream texture-overlay">
      <div className="container mx-auto">
        <AnimatedSection animation="fadeIn" delay={200}>
          <div className="elfsight-app-ec9ad137-c7e0-4197-bf30-0dbec7f9a7bb" data-elfsight-app-lazy></div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Videos;
